import { render, staticRenderFns } from "./MtsTebligatGonderIslemDetayView.vue?vue&type=template&id=17ce034c&scoped=true"
import script from "./MtsTebligatGonderIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./MtsTebligatGonderIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ce034c",
  null
  
)

export default component.exports